import React from 'react';
import { Button, Modal } from 'semantic-ui-react';

import { Flex, Box, Text, Icon } from 'Components/Base';
import { FONT_SIZE, SPACE } from 'Components/Theme';

const FlexProfileField = ({ label, value }) => (
  <Flex alignItems="baseline" pb={SPACE.small}>
    <Flex width={2 / 5} justifyContent="flex-end">
      <Text fontWeight="bold">{label}</Text>
    </Flex>
    <Flex width={3 / 5} ml={SPACE.medium} justifyContent="flex-start">
      <Text>{value}</Text>
    </Flex>
  </Flex>
);

const LinkSchoolManageModal = ({ open, onClose, mockExamStudentProfile, onManageExamClick }) => {
  const { firstName, lastName, studentCode, locationName } = mockExamStudentProfile || {};
  return (
    <Modal open={open} size="tiny" dimmer="inverted">
      <Modal.Content>
        <Modal.Description>
          <Box py={SPACE.medium}>
            <Text textAlign="center" mb={SPACE.medium} fontSize={[FONT_SIZE.large]}>
              <Icon name="warning sign" color="primary" /> คุณได้เชื่อมระบบโรงเรียนแล้ว
            </Text>
            <Box mb={SPACE.medium}>
              <FlexProfileField label="ชื่อ" value={`${firstName} ${lastName}`} />
              <FlexProfileField label="รหัสนักเรียน" value={studentCode} />
              <FlexProfileField label="โรงเรียน" value={locationName} />
            </Box>
            <Box css={{ textAlign: 'center' }}>
              <Button primary circular style={{ minWidth: '200px' }} onClick={onManageExamClick}>
                <Text is="span" fontWeight="400" color="white">
                  จัดการการสอบได้ที่นี่
                </Text>
              </Button>
              <Text textAlign="center" mt={SPACE.medium} mb={SPACE.medium}>{`หรือ`}</Text>
              <Button secondary circular onClick={onClose} style={{ minWidth: '200px' }}>
                <Text is="span" fontWeight="400" color="white">
                  เชื่อมระบบโรงเรียนอีกครั้ง
                </Text>
              </Button>
            </Box>
          </Box>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default LinkSchoolManageModal;
